import { useQuery } from "@tanstack/react-query";

import { api } from "./api";
import { useSession } from "./session";
import type { Listing, Payment } from "./types";

export interface Variant { id: number; name: string; sku: string; price: number; compare_at_price: number | null; available: number }
export interface Product extends Listing { name: string; is_demo: boolean; variants: Variant[]; listing_id: number | null; listing_slug: string | null }
export interface CartLine { variant: number; product_slug: string; name: string; variant_name: string; price: number; quantity: number; available: number; image: string | null; total: number }
export interface Cart { items: CartLine[]; count: number; subtotal: number }
export interface Totals { subtotal: number; shipping: number; discount: number; total: number }
export interface Zone { id: number; name: string; fee: number; description: string }
export interface Order extends Totals {
  id: string; number: string; status: string; status_label: string; reserved_until: string; created_at: string; paid_at?: string | null;
  delivery_mode: string; zone: string; tracking: string; customer: { name: string; email: string; phone: string; address: string; delivery_note: string };
  items: { name: string; sku: string; quantity: number; unit_price: number }[]; payments: Payment[];
}
export interface PaymentConfig { available: boolean; is_test: boolean; provider: string; message: string }

export function useCart() {
  const session = useSession();
  return useQuery({ queryKey: ["cart", session.data?.user?.id ?? "guest"], queryFn: () => api<Cart>("/cart/"), enabled: !session.isPending, refetchOnWindowFocus: true });
}

export function usePaymentConfig() {
  return useQuery({ queryKey: ["payment-config"], queryFn: () => api<PaymentConfig>("/payments/configuration/") });
}
